import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../../../redux/store';
import { useEffect, useState } from 'react';
import {
    asyncGetPqrSmartHistory,
    asyncRetryAck,
    asyncRetryM2,
} from '../../../../../../services/pqr.service';
import { Pqr } from '../../../../../../shared/types/modules/pqr';
import {
    ISelect,
    ParamEnum,
    SmartSupervisionEnum,
} from '../../../../../../shared/types/shared';

export const usePqrDetailActions = (pqr?: Pqr) => {
    const [open, setOpen] = useState<string>();
    const [resultRetry, setResultRetry] = useState<
        { type: string; result: any }[] | undefined
    >();
    const [loading, setLoading] = useState<boolean>(false);
    const [isM1, setIsM1] = useState<boolean>(false);
    const [isM2, setIsM2] = useState<boolean>(false);
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const navigate = useNavigate();
    const textBtnStyle = {
        display: {
            xs: 'none',
            lg: 'block',
        },
    };

    const btnIconStyle = { marginRight: { xs: -1, lg: undefined } };

    const canRetrySmartActions =
        type === 'admin' &&
        (pqr?.data?.type as ISelect)?.code === `${ParamEnum.PQR_TYPE}_QOR`;

    const handleRetry = async () => {
        if (!pqr?.id) return;
        setLoading(true);

        setResultRetry(
            open === 'M2'
                ? await asyncRetryM2(pqr.id)
                : await asyncRetryAck(pqr.id)
        );

        setLoading(false);
    };

    const handleClose = () => {
        setOpen(undefined);
        setResultRetry(undefined);
    };

    useEffect(() => {
        asyncGetPqrSmartHistory(pqr?.id || '', 0, 0, [
            SmartSupervisionEnum.MOMENT1_GET_ACK_FILES,
            SmartSupervisionEnum.MOMENT1_POST_ACK,
        ]).then((res: any) => {
            setIsM1(
                Boolean(
                    res?.items[0]?.type ===
                        SmartSupervisionEnum.MOMENT1_GET_ACK_FILES ||
                        res?.items[0]?.type ===
                            SmartSupervisionEnum.MOMENT1_POST_ACK
                )
            );
        });
        asyncGetPqrSmartHistory(pqr?.id || '', 0, 0, [
            SmartSupervisionEnum.MOMENT3_POST_COMPLAINT,
            SmartSupervisionEnum.MOMENT3_POST_STORAGE,
            SmartSupervisionEnum.MOMENT2_POST_COMPLAINT,
            SmartSupervisionEnum.MOMENT2_POST_STORAGE,
        ]).then((res: any) => {
            setIsM2(
                Boolean(
                    res?.items[0]?.type ===
                        SmartSupervisionEnum.MOMENT2_POST_COMPLAINT ||
                        res?.items[0]?.type ===
                            SmartSupervisionEnum.MOMENT2_POST_STORAGE ||
                        (canRetrySmartActions && !pqr?.dataSfc?.sfcId) ||
                        (canRetrySmartActions &&
                            pqr?.dataSfc?.sfcId &&
                            !res?.items[0]?.type.includes('MOMENT2') &&
                            res?.items[0]?.type.includes('MOMENT3'))
                )
            );
        });
    }, [pqr?.id]);

    return {
        canRetrySmartActions,
        navigate,
        textBtnStyle,
        btnIconStyle,
        open,
        setOpen,
        handleClose,
        handleRetry,
        resultRetry,
        loading,
        isM1,
        isM2,
    };
};
